import { inject, InjectionToken, PLATFORM_ID } from '@angular/core';
import { isPlatformServer } from '@angular/common';
import { Logger, logs } from '@opentelemetry/api-logs';
import { BatchLogRecordProcessor, LoggerProvider } from '@opentelemetry/sdk-logs';
import { OTLPLogExporter } from '@opentelemetry/exporter-logs-otlp-http';
import { resourceFromAttributes } from '@opentelemetry/resources';
import { EmporixSdkService } from 'haba-emporix';

export const OTEL_LOGGER = new InjectionToken<Logger>('OTEL_LOGGER');

export type OtelLogConfig = {
  serviceName: string;
  environment?: string;
};

export function createOtelLogger(cfg: OtelLogConfig): Logger {
  const platformId = inject(PLATFORM_ID);
  const emporixSdkService = inject(EmporixSdkService);
  const isServer = isPlatformServer(platformId);
  const serviceName = isServer ? `${cfg.serviceName}-ssr` : cfg.serviceName;

  const exporter = new OTLPLogExporter({
    url: emporixSdkService.buildSdkUrl('telemetryRecords'),
  });
  const resource = resourceFromAttributes({
    ['service.name']: serviceName,
    ['deployment.environment']: cfg.environment ?? 'dev',
    type: 'storefront',
  });

  const provider = new LoggerProvider({
    resource,
    processors: [new BatchLogRecordProcessor(exporter)],
  });
  logs.setGlobalLoggerProvider(provider);

  return provider.getLogger(serviceName);
}
